<template>
  <CModal
    title="Test Campaign"
    color="bg-orange"
    :show.sync="modalTestRun"
    size="xl"
  >
    <CCol sm="12">
      <template v-if="submitStatus == 'PENDING'">
        <div
          class="d-flex justify-content-center align-items-center mb-3"
          style="height: 300px"
        >
          <CSpinner color="custom-color" style="width:4rem;height:4rem;" />
        </div>
      </template>

      <template v-else>
        <CRow>
          <CCol sm="6">
            <CInput
              label="Email"
              placeholder="Enter your email"
              v-model="testRun.email"
            />
            <CInput
              label="SMS"
              placeholder="999 999 999"
              v-model="testRun.sms"
            />
            {{ submitStatus }}
          </CCol>
          <CCol sm="6">
            <CCallout class="mt-4">
              <div class="row">
                <div
                  class="col-7"
                  style="padding-top: 20px; padding-bottom: 20px;"
                ></div>
                <div class="col-5 p-4 text-right">
                  <h5 class="text-muted text-uppercase">Balance</h5>
                  <strong class="h5" style="font-size: 2rem;">{{balance}},00</strong>
                </div>
              </div>
            </CCallout>
          </CCol>
        </CRow>
        <CRow> </CRow>
        <CRow>
          <CCol sm="6" class="d-flex justify-content-end">
            <button @click="submit" class="btn btn-test mr-2">Test/Run</button>
          </CCol>
        </CRow>
      </template>
    </CCol>
  </CModal>
</template>

<script>
import service from "@/services.js";
import { required, minLength } from "vuelidate/lib/validators";
import fieldsValidate from "@/utils/fieldsValidate";
import Vuelidate from "vuelidate";
export default {
  name: "ModalTestRun",
  props:{
    id: {
      type: String,
    }
  },
  data() {
    return {
      balance : 0,
      modalTestRun: false,
      submitStatus: null,
      testRun: {
        email: null,
        sms: null
      }
    };
  },
  // mixins: [fieldsValidate],  no refactore usar mixins
  validations: {
    testRun: {
      email: {
        required,
        minLength: minLength(3)
      }
    },

    testRun: {
      sms: {
        required,
        minLength: minLength(9)
      }
    }
  },
  mounted() {
    this.$root.$on("modal-test-run", () => {
      this.modalTestRun = true;
    });

    this.balance = Math.floor((Math.random() * 1000) + 1)
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";

        service.testRunCampaign(this.id).then(response => {
          this.submitStatus = response.data.status == 'Ok' ? "SUCCESS" : "ERROR";
          this.balance = Math.floor((Math.random() * 1000) + 1)
        }).catch(error =>{
          //TODO tratar error
          this.submitStatus = error;
        })
      }
    }
  }
};
</script>

<style></style>
